import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAudioPlayer } from '@hooks/useAudioPlayer';
import { Pause, PlayArrow, VolumeOff, VolumeUp } from '@mui/icons-material';
import { Box, Button, IconButton, Slider, Typography } from '@mui/material';
export const AudioPlayer = ({ audioUrl }) => {
    const { isPlaying, currentTime, duration, volume, isMuted, togglePlay, seek, setVolume, toggleMute, audioRef, } = useAudioPlayer(audioUrl);
    const formatTime = (seconds) => {
        if (!isFinite(seconds) || seconds < 0)
            return '00:00';
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    // Calculate remaining time
    const remainingTime = duration - currentTime;
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'stretch', md: 'center' },
            gap: { xs: 2, md: 4 },
        }, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 2, md: 4 },
                    flex: { xs: 'none', md: 1 },
                }, children: [_jsx(Button, { variant: "contained", sx: {
                            height: 48,
                            width: 48,
                            minWidth: 48,
                            p: 0,
                            flexShrink: 0, // Prevent button from shrinking
                        }, onClick: togglePlay, children: isPlaying ? _jsx(Pause, {}) : _jsx(PlayArrow, {}) }), _jsxs(Box, { sx: { flex: 1, display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Box, { sx: { flex: 1 }, children: _jsx(Slider, { value: currentTime, max: duration || 100, onChange: (_, value) => seek(value) }) }), _jsxs(Typography, { variant: "caption", color: "text.disabled", fontWeight: 600, sx: {
                                    transform: 'translateY(-3px)',
                                    minWidth: 45,
                                    textAlign: 'right',
                                }, children: ["-", formatTime(remainingTime)] })] })] }), _jsxs(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    minWidth: { xs: 'auto', md: 240 },
                    width: { xs: '100%', md: 'auto' }, // Full width on mobile
                }, children: [_jsx(IconButton, { onClick: toggleMute, sx: { flexShrink: 0 }, children: isMuted || volume === 0 ? _jsx(VolumeOff, {}) : _jsx(VolumeUp, {}) }), _jsx(Box, { sx: { flex: 1 }, children: _jsx(Slider, { value: isMuted ? 0 : volume, onChange: (_, value) => setVolume(value) }) })] }), _jsx("audio", { ref: audioRef })] }));
};
